import { render, staticRenderFns } from "./ChangeLoanPermissionDialog.vue?vue&type=template&id=1da4e9b7&scoped=true"
import script from "./ChangeLoanPermissionDialog.vue?vue&type=script&lang=js"
export * from "./ChangeLoanPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeLoanPermissionDialog.vue?vue&type=style&index=0&id=1da4e9b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4e9b7",
  null
  
)

export default component.exports